export type PrimaryPricingOffer = 'subscription' | 'day_pass';

/**
 * A tool result or a quota gate signals interest in a Pro feature, not a
 * preference for a one-time purchase. Only an explicit day-pass entry point
 * changes the default. Keep the wallet-capable offer first for zh payments.
 */
export function getPrimaryPricingOffer(source: string, zhPayment: boolean): PrimaryPricingOffer {
  if (zhPayment) return 'day_pass';
  const normalized = source.toLowerCase().replace(/-/g, '_');
  const explicitDayPass = /^(?:day_pass|daypass|24_hour_pass)(?:$|:)/.test(normalized);
  return explicitDayPass ? 'day_pass' : 'subscription';
}
